angular.module('cvsApp').factory('validateDeepLinkModel',['commonModel',function(CM) {	
	'use strict';
	var validateDeepLinkModel = function(){

		var self = this;

		self.apiResponse = {};
		
		/*this.setResponse = function(data){
			setApiResponse(data);			
		}	

		this.getResponse = function(data){
			return getApiResponse();		
		}	*/

		this.setResponse = function(data){
			setApiResponse(data);
			CM.setResponse(data);			
		};	

		this.getResponse = function(data){
			self.apiResponse = CM.getResponse();
			self.header = getHeader();	
			return self;		
		};

		this.showView = function(){
			if(self.apiResponse.isViewError){	
				return !self.apiResponse.isViewError;
			}
			return true;
		};

		this.getError = function(){
			if(self.apiResponse.showError){	
				return self.apiResponse.showError;
			}
			return "";
		};

		var setApiResponse = function (data) {
			self.header = cvsUtility.xmlToJSON(data);
		};

		var getHeader = function () {
            if(self.header.hasOwnProperty('validateLinkResponse')){
                return self.header.validateLinkResponse.header;
            }
			return self.header.response.header;
		};

		this.setHardCodedResponse = function(data){
			self.apiResponse=data.apiResponse;
			self.header =data.header;
		}
	
	};
	
	return new validateDeepLinkModel();
}]);